import placeholder from '../assets/Illustration/farming1.jpeg';
import Irrigation_schedule from '../assets/screenshot/irrigation.png';
import fpo from '../assets/usecases/fpo.png';
import corporate from '../assets/usecases/corporate.webp';
// import seed from '../assets/usecases/seed.jpeg';
import Farmer from '../assets/about/farm.jpg';
import crop from '../assets/about/crop.jpg';
import drip from '../assets/about/drip.jpg';
import seed from '../assets/about/seed.jpg';
import plant from '../assets/about/plant_nutrition.png';

export const UsecaseData = [
  {
    title: 'Farmers',
    slug: 'farmer',
    image: Farmer,
  },
  {
    title: 'Contract/Corporate Farming Companies',
    slug: 'corporates',
    image: corporate,
  },
  {
    title: 'FPO',
    slug: 'fpo',
    image: fpo,
  },
  {
    title: 'Seed Companies',
    slug: 'seed-and-variety',
    image: seed,
  },
  {
    title: 'Crop Protection Companies',
    slug: 'crop-protection-company',
    image: crop,
  },
  {
    title: 'Plant Nutrition Companies',
    slug: 'plant-nutrition',
    image: plant,
  },
  {
    title: 'Drip Irrigation Companies',
    slug: 'drip-irrigation',
    image: drip,
  },
];

export const farmerUseCaseData = [
  {
    title: 'Irrigation Management',
    image: 'https://fyllo-temp-sharing.s3.ap-south-1.amazonaws.com/irrigation_screens/Grapes.png',
    description:
      ' Our irrigation schedule is based on soil type, crop, crop  stage and current moisture in the field. Our precise irrigation schedule helps farmers get the best crop and also avoid disease and pests.‍ ',
  },
  {
    title: 'Nutrient Management',
    image: 'https://fyllo-temp-sharing.s3.ap-south-1.amazonaws.com/crops/Grapes/fertigation.png',
    description:
      'Fyllo’s precise nutrient schedule is based on the current status of nutrients in the soil and in the plant. This data is provided through soil or leaf tests and our system generates a highly precise nutrient schedule. We consider crop stage, soil pH and nutrient interactions into the soil also into account while providing the fertigation schedule.',
  },
  {
    title: 'Disease and Pests Management',
    image: 'https://fyllo-temp-sharing.s3.ap-south-1.amazonaws.com/crops/Grapes/disease.png',
    description:
      'We provide predictions for diseases and pests and preventive schedules such that they can be controlled. We have these models available for over 100 disease/pests and 20+ crops. Our schedule considers MRL and PHI of the molecules and lower cost of cultivation.',
  },
  {
    title: 'Live farm Weather and Weather Prediction',
    image: 'https://fyllo-temp-sharing.s3.ap-south-1.amazonaws.com/crops/commons/weather.png',
    description:
      'Our device installed at farm captures live data at the farm level. This data along with global numerical weather models is used to predict weather at microclimate level. Our weather prediction models are 50% more accurate than location-based weather predictions.',
  },
  {
    title: 'Crop Specific Alerts',
    image: 'https://fyllo-temp-sharing.s3.ap-south-1.amazonaws.com/crops/Grapes/main.png',
    description:
      'Get the evapotranspiration rate, best harvest time, climate related risks at different stage of the crop with the help of fyllo.‍',
  },
];

export const CorporateUseCaseData = [
  {
    title: 'Dashboard (Area wise visibility on crops, tags, Alerts)',
    image: placeholder,
    description:
      ' You can visualize what’s happening at all farms. You can also manage the alerts for activities, monitor disease/pest probability, irrigation requirements and climate risks at every plot.‍',
  },
  {
    title: 'Yield and quality prediction‍',
    image: placeholder,
    description:
      'Fyllo provides yield and quality prediction at each farm level beforehand so that you are always in control of the produce. ',
  },
  {
    title: 'Personalized App and Alerts to farm managers/workers',
    image: placeholder,
    description: 'With Fyllo, all the farm managers are alerted on various actions to be taken beforehand.',
  },
  {
    title: 'Satellite Imagery and Crop health monitoring:',
    image: placeholder,
    description:
      'Our device installed at farm captures live data at the farm level. This data along with global numerical weather models is used to predict weather at microclimate level. Our weather prediction models are 50% more accurate than location-based weather predictions.',
  },
  {
    title: 'Reach your ESG goals‍',
    image: placeholder,
    description:
      'With fyllo’s solutions of growing best crops with less inputs, you can easily monitor and achieve your ESG goals.‍',
  },
];
export const FPOUseCaseData = [
  {
    title: 'Less devices, more farms:‍',
    image: placeholder,
    description:
      ' Our device sharing model where the data from same device can be shared to provide insights to multiple nearby farmers on different crops, works best for FPOs. One device installed can provide accurate advisories to all the nearby farmers.‍',
  },
  {
    title: 'App for all farmers :‍',
    image: placeholder,
    description:
      'Every farmer gets Fyllo mobile app with personalized advisories according to his soil, crop and farm.',
  },
  {
    title: 'Dashboard for FPO Management :',
    image: placeholder,
    description:
      'The FPO management has access to all farms data, satellite imagery, actions performed, disease and pest probability in each farm on the web dashboard.',
  },
  {
    title: 'Book a meeting to explore our FPO offerings now',
    description: '',
  },
];

export const SeedVarietyCaseData = [
  {
    title: 'Manage disease/pests in different varieties:',
    image: placeholder,
    description:
      'Fyllo provides you climate-based disease and pest prediction that you can use to monitor effect of different pathogens on the varieties being developed.',
  },
  {
    title: 'Conduct multi location, multi – climatic zone trials:',
    image: placeholder,
    description:
      'With Fyllo device and dashboard providing you the micro-climate data, you can monitor your trials in different microclimatic zones and be confident on the crops being climate proof.',
  },
  {
    title: 'Set package of practices for new varieties: ',
    image: placeholder,
    description:
      'In the trial locations, you can set package of practices for irrigation, fertigation and disease/pest management that work the best for your variety. ',
  },
  {
    title: 'Provide season long support to initial growers:',
    image: placeholder,
    description: 'As a seed company, you can help the initial growers get the best out of the variety. ',
  },
];
export const CropProtectionCaseData = [
  {
    title: 'Disease/pests risks across crops and locations:  ',
    image: placeholder,
    description:
      'You  can visualize the risk of diseases and pests across locations and crops and can do the marketing plans according to that.   You can also get history of disease/pests predictions. ',
  },
  {
    title: 'Weather dashboard: ',
    image: placeholder,
    description: 'You get live and historical climate data and all over the country and weather prediction too',
  },
  {
    title: 'Crop and stage monitoring with the help of satellite:',
    image: placeholder,
    description: 'You can get the live crop and stage data with the help of satellite imagery',
  },
  {
    title: 'Explore Partnership With Fyllo',
  },
];
export const PlantNutritionCaseData = [
  {
    title: 'Develop new crop specific fertigation category ',
    image: placeholder,
    description:
      'Develop new crop specific fertigation category With Fyllo, farmers get precise irrigation schedule. You can match irrigation with fertigation and develop an specialized brand of fertilizer for particular crop. ',
  },
  {
    title: 'Get area wise climate data',
    image: placeholder,
    description:
      ' With Fyllo dashboard you can get area specific farm climate data so that your products can be climate smart. ',
  },
  {
    title: 'Crop and stage monitoring with the help of satellite',
    image: placeholder,
    description: 'You can get the live crop and stage data with the help of satellite imagery.',
  },
  {
    title: 'Explore Partnership With Fyllo',
  },
];

export const DripIrrigationCaseData = [
  {
    title: 'You can offer Fyllo products to your customers that increases your range of offerings.',
  },
  {
    title:
      'At the places where farmers are not adopting micro irrigation techniques, proper irrigation can help you increase the market of your products.',
  },
  {
    title:
      'With Fyllo Support App, you get drip design module that can help you design the perfect drip for your clients. Our model takes input soil type, crop and age of plant while designing drip. ',
  },
];
